export default "__VITE_ASSET__CRC85WxJ__"